var InRegPlanConfig = function(){

    var _price = function( plan, freq ){
        var texts = {
            mth: 'Pay $:price monthly',
            yr: 'Pay $:price yearly',
        }
        return texts[freq].replace(':price',ecomConf.prices[plan][freq]);
    }

    var _init = function(arg){
        Auth.registerForm(); //change to loginForm() if the default active tab changes to login in the auth-tabbed blade
        $('.reg-error').addClass('d-none').removeClass('d-block');
        $('#reg-elements').show();
        $('#inreg-plan-chooser').val(arg.plan).trigger('change');
        $('#payment-element').empty();
        var freq = $('#pay-freq').is(':checked') ? 'mth' : 'yr';
        InRegPlanConfig.payCheck(freq);
        InRegPlanConfig.payHow(arg.plan);
    }

    var _payHow = function( plan ){
        $('#register-next').text(ecomConf.trans.regText[plan]).removeClass('d-none').addClass('d-block');
        Debug.log('cartMeta',cartMeta);
        if(plan == 'MEMBER'){
            $('#present-card').addClass('d-none');
            $('#inreg-free').addClass('d-block').removeClass('d-none');
            $('#inreg-pay-group').addClass('d-none').removeClass('d-block');
        }else{
            $('#inreg-pay-mth').parent().find('label').text(InRegPlanConfig.price(plan,'mth'))
            $('#inreg-pay-yr').parent().find('label').text(InRegPlanConfig.price(plan,'yr'))
            $('#inreg-free').addClass('d-none').removeClass('d-block');
            $('#inreg-pay-group').addClass('d-block').removeClass('d-none');
            $('#modal-onetime-form').empty();
            if( typeof cartMeta == 'object' && cartMeta.u ){
                $('#register-next').addClass('d-none').removeClass('d-block');
                $('#present-card').removeClass('d-none');
                $('#legal-elements').hide();
            }else{
                $('#register-next').removeClass('d-none').addClass('d-block');
                $('#legal-elements').show();
            }
        }
        if( typeof cartMeta == 'object' && cartMeta.u ){
            Do.Ajax('/auth/mount',{
                u:cartMeta.u,
                p:$('#inreg-plan-chooser').val(),
                f:$('input[name="inreg-pay-choice"').val()
            });
        }
    }

    var _payCheck = function(freq){
        $('#inreg-pay-'+freq).prop('checked',true)
    }

    var _watch = function(){
        $('#inreg-plan-chooser').select2({minimumResultsForSearch:Infinity})
            .on('select2:select',function(e){
                InRegPlanConfig.payHow($('#inreg-plan-chooser').val());
            }
        );
        $('input[name="inreg-pay-choice"').off().on('change',function(){
            InRegPlanConfig.payHow($('#inreg-plan-chooser').val());
        });
        $('.legal-checks').off().on('change',function(){
            if( $(this).is(':checked')){
                $('#error-'+$(this).attr('id')).removeClass('d-block').addClass('d-none');
            }
        });
        $('#register-next').off().on('click',function(){
            Do.Ajax('/auth/register',{ form: $('#modal-reg-form').serializeJSON()});
        });
    }

    return {
        init: function(a){
            _init(a);
        },
        payHow: function(p){
            _payHow(p);
        },
        payCheck: function( f ){
            return _payCheck( f );
        },
        price: function( p,f ){
            return _price( p,f );
        },
        watch:function(){
            _watch();
        }
    }
}();

var Subscription = function(){

    let _prepareForCard = function(r){
        $('#legal-elements').hide('slow');
        $('.reg-error').addClass('d-none').removeClass('d-block');
        $('#register-next').addClass('d-none').removeClass('d-block');
        $('#reg-elements').hide('slow');
        $('#present-card').removeClass('d-none');
        $('#auth-tabs a[href="#auth-tab-login"]').addClass('d-none disabled')
        $('#auth-tabs a[href="#auth-tab-register"]').empty().html(ecomConf.trans.created);
        $('#pay-button').on('click touchstart',function(e){
            handleCartSubmit(e);
        });
    }

    let _paintLogin = function(r){
        $('#modal-login-form').html(r.elements);
        Auth.awaitLogin($('#login-form'))
    }

    let _paintRegister = function(r){
        $('#reg-elements').html(r.elements);
    }

    return {
        card:function(r){
            _prepareForCard(r);
            cartMeta = r.u;
            CartUtils.mountPayElement( r )
            $('.auth-welcome-header').text(ecomConf.trans.welcome.replace(':fullname',r.u.f+' '+r.u.l));
        },
        loginForm:function(r){
            _paintLogin(r);
        },
        registerForm:function(r){
            _paintRegister(r);
        },
    }

}();

$(document).ready(function(){
    $('#auth-tabs a[data-toggle="tab"]')
        .on('show.bs.tab',function(){
            $('.legals-collapse').collapse('hide');
            if( $(this).attr('href') == '#auth-tab-login' ){
                Auth.loginForm();
                $('#present-card').addClass('d-none');
            }else{
                Auth.registerForm();
            }
        });
    $('#modal-tabbed-auth').on('show.bs.modal',function(e){
        var plan = $(e.relatedTarget).data('plan');
        $('#register-next').text(ecomConf.trans.regText[plan]).removeClass('d-none').addClass('d-block');
        InRegPlanConfig.init({ plan:plan });
        InRegPlanConfig.watch({});
    });
});